import type { DeviceStorage } from '@frontend/deviceStorage';
import type { State } from '@frontend/state';
import type { Settings } from '@frontend/Settings';
import LazyDependencyContainer from '@phi/lazy-dependency-container';
import * as logging_jcore from '@frontend/JCore/logging_jcore';
import { IEdgeTightness, edge_tightness_provider } from '@features/edge-tightness';
import { type ILogging, logging_factory } from '@phi/logging/frontend';
import { type IAuthentication, authentication_provider } from '@phi/authentication/frontend';
import { IFrontentUtilities, util_factory } from './util';
import { ISavingLoading, saving_loading_factory } from '@phi/saving-loading';
import { JSONRPCAPI } from './api/provider';
import { type ISubscriptions, subscriptions_provider } from '@phi/subscriptions/frontend';
import type { IAnalytics } from '@phi/analytics';
import { IPopUnderWithRouter, pop_under_with_router_provider } from '@phi/pop-under-with-router';

export type IFrontendServiceContainer = {
    device_storage: DeviceStorage;
    state: State;
    settings: Settings;
    logging_jcore: typeof logging_jcore;
    edge_tightness: IEdgeTightness;
    logging: ILogging;
    authentication: IAuthentication;
    util: IFrontentUtilities;
    saving_loading: ISavingLoading;
    api: JSONRPCAPI;
    subscriptions: ISubscriptions;
    analytics: IAnalytics;
    pop_under_with_router: IPopUnderWithRouter;
};

export const instance: IFrontendServiceContainer = {} as any;

export const frontend_service_container_provider = (
    device_storage: DeviceStorage,
    state: State,
    settings: Settings,
    api_provider: () => JSONRPCAPI,
    analytics: IAnalytics,
): IFrontendServiceContainer => {
    const container = LazyDependencyContainer<IFrontendServiceContainer>({
        api: api_provider,
        device_storage: () => device_storage,
        state: () => state,
        settings: () => settings,
        logging_jcore: () => logging_jcore,
        edge_tightness: edge_tightness_provider,
        logging: logging_factory,
        authentication: authentication_provider,
        util: util_factory,
        saving_loading: saving_loading_factory,
        subscriptions: subscriptions_provider,
        analytics: () => analytics,
        pop_under_with_router: () => pop_under_with_router_provider(),
    });
    for (const [k, v] of Object.entries(container))
        // @ts-ignore
        instance[k] = v;
    return instance;
};

export const frontend_service_container = (): IFrontendServiceContainer => instance;
